import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
// JSS
import { RichText } from '@sitecore-jss/sitecore-jss-react'; // Type defintitions

import * as TYPES from '../../types'; // Design System

import Wrapper from '../wrapper/Wrapper';
import ContentBlockTile from './ContentBlockTile';

var ContentTileWrapper = function ContentTileWrapper(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      alignment = props.alignment,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? {} : _props$layout,
      _props$className = props.className,
      className = _props$className === void 0 ? "cb-content-block__tilealone" : _props$className;
  var type = {
    sm: '12',
    lg: '6'
  };

  if (typeof layout.type !== 'undefined') {
    if (layout.type === 'list') {
      type.lg = '3';
    }
  }

  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    alignment: alignment
  }, /*#__PURE__*/React.createElement(ContentBlockTile, _extends({
    model: model,
    alignment: alignment,
    className: className
  }, props)));
};

export default ContentTileWrapper;